import React from 'react';
import {Modal, InputItem} from 'antd-mobile';
import {createForm} from 'rc-form';
// import {valideImageCode} from '../../assets/xhr';

class ImageCodeModal extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            visible: true,
            value: '',
            time: +new Date()
        }
    }
    onConfirm = ()=>{
        // 校验图形验证码
        let {value, time} = this.state;
        if (value && value.length < 4){
            this.setState({
                errorText: $st('验证码输入不正确')
            });
            return;
        }
        let callback = this.props.callback;
        callback && callback({
            code: value,
            cid: time
        });
        // valideImageCode(value, time, (response)=>{
        //     let {code, message} = response;
        //     let callback = this.props.callback;
        //     if (code === 0){
        //         //验证成功
        //         callback && callback({
        //             code: value,
        //             cid: time
        //         });
        //         this.setState({
        //             visible: false,
        //             value: '',
        //             time: +new Date()
        //         });
        //     }else{
        //         this.setState({
        //             errorText: message
        //         })
        //         this.updateCode()
        //         // Toast.info(message, 1.5);
        //         // this.setState({
        //         //     time: +new Date()
        //         // })
        //     }
        // });
    }
    onCancel = ()=>{
        this.setState({
            visible: false
        });
        let callback = this.props.callback;
        callback();
    }
    onChange = (val)=>{
        this.setState({
            value: val,
            errorText: ''
        })
    }
    updateCode = ()=>{
        this.setState({
            time: +new Date()
        })
    }
    render(){
        let props = {
            title: $st('请输入验证码'),
            transparent: true,
            maskClosable: false,
            visible: this.state.visible,
            footer: [{text:$st('取消'), onPress: this.onCancel}, {text: $st('确定'), onPress: this.onConfirm}]
        };
        let {errorText, value} = this.state;
      let codeUrl = `/FSC/N/Captcha/Get?cid=${this.state.time}&lan=en`;

        return (
            <Modal {...props}>
                <div className="image-code">
                    <InputItem className="image-code__input" error={errorText} value={value} onChange={this.onChange} />
                    <img className="image-code__code" src={codeUrl} onClick={this.updateCode}  alt={$st("图形验证码")}/>
                </div>
            </Modal>
        )
    }

}
export default createForm()(ImageCodeModal);



// WEBPACK FOOTER //
// ./src/component/ImageCode/ImageCodeModal.js